import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const Container = styled(Stack)`
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  border-radius: 8px;
`;

export const BorderLine = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
`;

export const CheckBoxInput = styled.input`
  width: 14px;
  height: 14px;
`;
